import map from 'lodash/map';
import { breadcrumbsRetrievedType, setBreadcrumbsOrderType } from './BreadcrumbsConstants';
import {
  retrieveBreadcrumbs as retrieveBreadcrumbsHelper,
  goToResultPage as goToResultPageHelper,
  backToQueryHandler as backToQueryHandlerHelper,
  createAlert as createAlertHelper,
  updateBreadcrumbData as updateBreadcrumbDataHelper,
  openBatchExecutionDetails as openBatchExecutionDetailsHelper,
  showStructurePopup as showStructurePopupHelper,
} from './BreadcrumbsHelper';

export function retrieveBreadcrumbs(databaseId) {
  return async (dispatch) => {
    const breadcrumbs = await retrieveBreadcrumbsHelper(databaseId);
    const breadcrumbsWithComments = await Promise.all(
      map(breadcrumbs, (breadcrumb) => {
        return breadcrumb.comment ? breadcrumb : updateBreadcrumbDataHelper(breadcrumb);
      })
    );

    dispatch({
      type: breadcrumbsRetrievedType,
      breadcrumbs: breadcrumbsWithComments,
    });

    return breadcrumbs;
  };
}

export function setBreadcrumbsOrder(breadcrumbsOrder) {
  return {
    type: setBreadcrumbsOrderType,
    breadcrumbsOrder,
  };
}

export function goToResultPage(crumb) {
  return () => {
    return goToResultPageHelper(crumb);
  };
}

export function backToQueryHandler(breadcrumb, action) {
  return () => {
    return backToQueryHandlerHelper(breadcrumb, action);
  };
}

export function createAlert(breadcrumb) {
  return () => {
    return createAlertHelper(breadcrumb);
  };
}

export function openBatchExecutionDetails(breadcrumb) {
  return () => {
    return openBatchExecutionDetailsHelper(breadcrumb);
  };
}

export function showStructurePopup(structure) {
  return () => {
    return showStructurePopupHelper(structure);
  };
}
